export default __webpack_public_path__ + "static/Tek_Trough-21b3e2e3f17188731ff4e93e08d79e6c.png";